"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStaticImageMenuItem = isStaticImageMenuItem;
exports.isStaticTextMenuItem = isStaticTextMenuItem;
exports.isStandardMenuItem = isStandardMenuItem;
exports.isOpenURLMenuItem = isOpenURLMenuItem;
function isStaticImageMenuItem(item) {
    return !!item && !!item.imageUrl;
}
function isStaticTextMenuItem(item) {
    return !!item && !!item.body;
}
function isStandardMenuItem(item) {
    return !!item && !!item.label;
}
function isOpenURLMenuItem(item) {
    return !!item && !!item.url;
}
//# sourceMappingURL=guards.js.map